import * as React from 'react';

import user from 'js/lib/user';

import SubscriptionVPropBulletPoint from 'bundles/enroll-modal/components/subscriptions/free-trialV2/SubscriptionVPropBulletPoint';
import { getFreeTrialBullets } from 'bundles/enroll-modal/components/subscriptions/free-trialV2/utils/bulletData';
import usePageData from 'bundles/enroll-modal/data/usePageData';
import ReactPriceDisplay from 'bundles/ownable-products-common/components/ReactPriceDisplay';

import 'css!./__styles__/SubscriptionPropBulletPoints';

const SubscriptionPropBulletPoints = () => {
  const { s12nDerivatives, s12nSubscriptionOwnableProduct, s12n } = usePageData();
  const s12nProductPrice = s12nSubscriptionOwnableProduct?.price || s12nDerivatives?.catalogPrice;

  if (!(s12n && s12nProductPrice)) {
    return null;
  }
  const monthlyPrice = <ReactPriceDisplay currency={s12nProductPrice.currencyCode} value={s12nProductPrice.amount} />;
  const { FREE_TRIAL_LOGGED_IN_BULLETS, FREE_TRIAL_LOGGED_OUT_BULLETS } = getFreeTrialBullets({
    s12nProductVariant: s12n.productVariant,
  });

  const bullets = user.isAuthenticatedUser() ? FREE_TRIAL_LOGGED_IN_BULLETS : FREE_TRIAL_LOGGED_OUT_BULLETS;

  return (
    <div className="rc-SubscriptionPropBulletPoints">
      <ul className="bullet_list nostyle">
        {bullets.map((bullet) => {
          return (
            <li key={`bullet_${bullet.header}`}>
              <SubscriptionVPropBulletPoint messageProps={{ monthlyPrice }} highlightHeader={true} {...bullet} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SubscriptionPropBulletPoints;
